// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3r9nT","col":"CardReaderDesc_col__3Fbbl","label":"CardReaderDesc_label__rLzXs"};